export enum AnalysisType {
  CARBON = 'carbon',
  DENSITY = 'density',
}
